import { CustomPreference } from '../../utils/api/CustomPreference';

export const preloadCustomPreferences: string[] = Object.values(CustomPreference);
